import { render, staticRenderFns } from "./DemoBoostDialog.vue?vue&type=template&id=690745a8&"
import script from "./DemoBoostDialog.vue?vue&type=script&lang=js&"
export * from "./DemoBoostDialog.vue?vue&type=script&lang=js&"
import style0 from "./DemoBoostDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports